export function shouldAcknowledgeChatRead(input: {
  latestSeq: number | undefined;
  timelinePositioned: boolean;
  isAtLatest: boolean;
  visibilityState: DocumentVisibilityState;
}): input is typeof input & { latestSeq: number } {
  return (
    Boolean(input.latestSeq) &&
    input.timelinePositioned &&
    input.isAtLatest &&
    input.visibilityState === 'visible'
  );
}
